import { Component, OnInit } from '@angular/core';
import { SeiService } from '../../services/sei.service';
import { ProaService } from '../../services/proa.service';
import { PesquisaGeralService } from 'src/app/modules/projeto-completo/services/pesquisa-geral.service';
import { ProjetoCadastro } from 'src/app/modules/projeto-completo/models/projeto-cadastro.model';

@Component({
  selector: 'app-processo-all-list',
  templateUrl: './processo-all-list.component.html',
  styleUrls: ['./processo-all-list.component.scss']
})
export class ProcessoAllListComponent implements OnInit {
  currentMenu: any;

  constructor(
    public seiService: SeiService,
    public proaService: ProaService,
    private pesquisaGeralService: PesquisaGeralService,
  ) { }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.currentMenu = info?.menu?.proa;
    });
  }

}
